'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var careers = exports.careers = {
  title: 'Get ready for the Career of your life',
  description: 'Learn everything you’ve always wanted to learn, and get the job of your dreams. Nothing can stop you anymore',
  view_careers: 'See Careers',
  how_it_works_title: 'How do Careers work?',
  how_it_works_description: 'Pick a Career, select a Plan, and you are in',
  hiw_find_a_career: 'Find your Career',
  hiw_find_a_career_explained: 'What is your vocation? Find your Career, you can do as many as you would like',
  hiw_subscribe: 'Pick a plan',
  hiw_subscribe_explained: 'Select the plan that better fits your interests. From Monthly to Yearly',
  hiw_learn: 'Access the courses',
  hiw_learn_explained: 'Start your learning journey and work on your Career at your own pace',
  hiw_certificates: 'Certify your training',
  hiw_certificates_explained: 'Get a certificate for completing your courses and Career. You did it!',
  find_a_career: 'Find your ideal Career',
  view_less: 'See less',
  view_all: 'See all',
  select_a_plan_title: 'Pick a plan for your Career',
  select_a_plan_description: 'Select the plan that best fits your needs. You can stop or cancel it at any time',
  faq: 'Frequently asked questions',
  faqs: JSON.stringify([{ q: 'What will I learn by studying a Career?',
    a: 'Careers will help you to become a professional on the topic you select. With a Career, you will become who you’ve always wanted to be and will be able to work in your dream job' }, { q: 'Can I enroll in any Career?',
    a: 'Yes. Previous knowledge is not required, all Careers start from a beginner’s level and get to high professional levels. Our advice is to pick the Career most interesting to you, and move to another once you’ve finished.' }, { q: 'What additional benefits do I get from a Career?',
    a: 'You will have a unique and carefully designed Learning Path, as well as a personal Tutor, someone who will help and mentor you during the journey. You will also get the support of the community and teachers within the Career.' }, { q: 'How do I get into a Career?',
    a: 'Careers are purchased through Subscriptions. Pick the subscription plan best suited to you (we recommend the Yearly plan, since it is the cheaper option) and start changing your life right now.' }, { q: 'How much time do I have to finish a Career?',
    a: 'As much as you want or need. The minimum time is one month, yet it is normal to take multiple months to finish a Career. You can however pause your career at any time and come back to it as you would like.' }])
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/careers.js
// module id = 711
// module chunks = 0